import React from 'react'
import mayapurisckon from "../images/mayapur isckon.jpg";

function Projectpage() {
  return (
    <div>
  
      <br/>
         <div className="album py-2">

                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">
<div className="card-body">
    <h1 className="card-title"><b style={{color:"#F2192E"}}>Our Projects</b>– Saha Refrigeration & Air Conditions</h1>
    <p className="card-text justify">At Saha Refrigeration & Air Conditions, we take pride in successfully completing a wide range of air conditioning projects across Krishnanagar, Mayapur, including prestigious locations such as ISKCON Mayapur, and surrounding areas of Nadia district.</p>

  </div>

                                </div>
                                    <div className="col-md-5">

  <img src={mayapurisckon} className="card-img-top" alt="mayapurisckon"/>

                                </div>
                                </div>
                                </div>

                            </div>
    </div>
  )
}

export default Projectpage